import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b6261f3a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=b6261f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6261f3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6261f3a')) {
      api.createRecord('b6261f3a', component.options)
    } else {
      api.reload('b6261f3a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b6261f3a&scoped=true&", function () {
      api.rerender('b6261f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d0DZVpOGwPYV/JS/comp/SearchFilterTokens.vue"
export default component.exports